import api from "./api";
import layout from "@/_store/layout.module"
import {isEmpty} from "lodash";
import L from "leaflet";

export const circuitService = {
  getOneCircuit,
  getAllCircuits,
  addCircuit,
  addPole,
  getPole,
  updatePole,
  editCircuit,
  deleteCircuit,
  deletePole,
  polesWithNoDeviceInstalled,
  getCustomerRegions
};

async function getOneCircuit(uuid) {
  let circuit = (await api.get("/cable-health-broker/v1/circuits/" + uuid)).data
  circuit = calculateCenterOfCircuit([circuit])[0]
  circuit.bounds = [[circuit.bounds[0]["latitude"], circuit.bounds[0]["longitude"]], [circuit.bounds[1]["latitude"], circuit.bounds[1]["longitude"]]]
  return circuit
}

async function getAllCircuits() {
  let url = "/cable-health-broker/v1/circuits"
  if (!layout.state.hideInactiveCircuits) {
    url += "?inactive=true"
  }
  let circuits = (await api.get(url)).data.circuits
  return calculateCenterOfCircuit(circuits)
}


function addCircuit(circuit) {
  return api.post("/cable-health-broker/v1/circuits", circuit);
}

function editCircuit(circuit, circuit_uuid) {
  return api.patch(`/cable-health-broker/v1/circuits/${circuit_uuid}`, circuit)
}

function deleteCircuit(circuit_uuid) {
  return api.delete(`/cable-health-broker/v1/circuits/${circuit_uuid}`)
}

function addPole(circuitUuid, pole) {
  return api.post("/cable-health-broker/v1/circuits/" + circuitUuid + "/poles", pole);
}

function getPole(circuitUuid, poleUuid) {
  return api.get("/cable-health-broker/v1/circuits/" + circuitUuid + "/poles/" + poleUuid);
}

function updatePole(circuitUuid, poleUuid, pole) {
  return api.patch("/cable-health-broker/v1/circuits/" + circuitUuid + "/poles/" + poleUuid, pole);
}

function deletePole(circuitUuid, poleUuid) {
  return api.delete("/cable-health-broker/v1/circuits/" + circuitUuid + "/poles/" + poleUuid);
}


async function polesWithNoDeviceInstalled() {
 let circuits = await getAllCircuits()
 let poles = []
 if (circuits.length > 0) {
  circuits.forEach(function (circuit) {
   poles.push(...circuit.poles);
  });
  if (poles.length > 0) {
   poles = poles.filter(pole => pole.pole_substation_number != null && !pole.device);
  }
 }

 return poles;
}

function calculateCenterOfCircuit(circuits) {
  circuits.forEach((circuit, index) => {
  let center = null
  if (!isEmpty(circuit.bounds)) {
      let corner1 = L.latLng(circuit.bounds[0]["latitude"], circuit.bounds[0]["longitude"])
      let corner2 = L.latLng(circuit.bounds[1]["latitude"], circuit.bounds[1]["longitude"])
      center = L.latLngBounds(corner1, corner2).getCenter()
  }
  circuits[index].center = center
  })
  return circuits
}

function getCustomerRegions() {
  return api.get("/cable-health-broker/v1/circuits/regions/available_regions");
}